import { render, staticRenderFns } from "./IframeGuide.vue?vue&type=template&id=2b1f8b27&scoped=true&lang=html&"
import script from "./IframeGuide.vue?vue&type=script&lang=js&"
export * from "./IframeGuide.vue?vue&type=script&lang=js&"
import style0 from "./IframeGuide.vue?vue&type=style&index=0&id=2b1f8b27&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1f8b27",
  null
  
)

export default component.exports